var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('input',{staticClass:"input-field",attrs:{"placeholder":_vm.placeholder,"name":_vm.name,"type":_vm.type,"step":_vm.step},domProps:{"value":_vm.value},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }